import { AxiosResponse } from 'axios'
import React, { useEffect } from 'react'
import { apiCall, ApiConfig } from '../../../../config/api'
import { Modal } from '../../../Modal'
import { Loading } from '../../../UI'
import snackbarBusiness from '../../actions/snackbarBusiness'
import typePositionBusiness from '../../actions/typePositionBusiness'
import { useTypePosition as useTypePositionContext } from '../../context'
import { TypePosition } from '../../types/TypePosition'
import { TypePositionEditForm } from './TypePositionEditForm'
import { useTypePosition } from '../../../../hooks'

interface TypePositionEditProps {}

export const TypePositionEdit: React.FC<TypePositionEditProps> = () => {
  const {
    state: {
      editModalState: { open, typePositionId },
      selectedTypePosition
    }
  } = useTypePositionContext()

  const { getTypePositions } = useTypePosition()

  const { errorMessage } = snackbarBusiness()

  const { closeEditModal, handleLoading, handleSelectedTypePosition } =
    typePositionBusiness()

  // hacer el fetch del tipo de posición
  const fetchTypePosition = () => {
    handleLoading(true)
    apiCall('GET', `${ApiConfig.TypepositionApi}/${typePositionId}`)
      .then(({ data }: AxiosResponse<TypePosition>) =>
        handleSelectedTypePosition(data)
      )
      .catch(errorMessage)
      .finally(() => handleLoading(false))
  }

  useEffect(() => {
    if (typePositionId > 0) {
      fetchTypePosition()
    } else {
      getTypePositions()
    }
  }, [typePositionId])

  return (
    <Modal
      funcClose={() => closeEditModal()}
      isOpen={open}
      backdropClick={false}
      size='XS'
      title='Editar Tipo Posición'
    >
      {selectedTypePosition === undefined ? (
        <Loading />
      ) : (
        <TypePositionEditForm typePosition={selectedTypePosition} />
      )}
    </Modal>
  )
}
